import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const tablePaginatorStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
  })
);
